import { render, staticRenderFns } from "./UploadIconRequired.vue?vue&type=template&id=1d578b30&scoped=true&"
import script from "./UploadIconRequired.vue?vue&type=script&lang=ts&"
export * from "./UploadIconRequired.vue?vue&type=script&lang=ts&"
import style0 from "./style.scss?vue&type=style&index=0&id=1d578b30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d578b30",
  null
  
)

export default component.exports